import React from "react";
import Image from "gatsby-image/withIEPolyfill";
import css from "@styled-system/css";

import { Box } from "components";

function LargeGraphic({ image, offset }) {
  return (
    <Box
      data-component-id="homeHero.largeGraphic"
      position="relative"
      display={{ _: "none", lg: "block" }}
      css={{ pointerEvents: "none" }}
    >
      <Box position="absolute" top={0} left={offset + 64}>
        <Box
          bg="brand.secondary"
          css={css({
            //IE11 Fallback
            minWidth: "166.65vh",
            minWidth: "calc(var(--vh, 1vh) * 166.65)", // We use CSS variables for this to keep vertical height units static on iOS
            //IE11 Fallback
            minHeight: "166.65vh",
            minHeight: "calc(var(--vh, 1vh) * 166.65)", // We use CSS variables for this to keep vertical height units static on iOS
            clipPath: "polygon(30% 0, 100% 0%, 100% 100%, 100% 100%, 0 60%)",
          })}
        >
          <Box position="absolute" left={0} top={0} right={0} bottom={0}>
            <Image
              fluid={image.fluid}
              alt={image.alt}
              objectFit="cover"
              objectPosition="0% 100%"
              css={{
                width: "100%",
                height: "100%",
              }}
            />
            {/* Soft top scrim */}
            <Box
              position="absolute"
              top={0}
              left={0}
              width="100%"
              height="100%"
              opacity={0.2}
              css={{
                background: "linear-gradient(to bottom, #000, transparent 33%)",
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default LargeGraphic;
